import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import { ConfirmationDialog, Flashcard, FlashcardModal } from 'components';
import { areCardsEqual } from 'utilities/sideNavUtils';

const FlashcardDeleteDialog = ({
  isOpen,
  cancelOnClick,
  deleteOnClick,
  ...props
}) => {
  return (
    <ConfirmationDialog
      cancel={{ label: 'Cancel', action: () => cancelOnClick() }}
      confirm={{
        label: 'Delete',
        action: () => {
          deleteOnClick();
        },
      }}
      id={'confirmDeleteFlashcardDialog'}
      isOpen={isOpen}
      labelledById="flashcard-delete-confirmation"
      message="Deleting the flashcard will permanently remove it from this material."
      title="Are you sure you want to proceed?"
      titleComponent="h4"
      {...props}
    />
  );
};

const arePropsEqual = (prevProps, nextProps) => {
  return areCardsEqual(prevProps, nextProps, [
    'confidenceLevel',
    'isPersisted',
    'isSaved',
    'isSwapped',
    'snippet',
    'userText',
  ]);
};

const FlashcardListCard = memo(({ contentItem }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const editOnClick = () => {
    setIsEditing(true);
  };
  const deleteOnClick = () => {
    setConfirmDelete(true);
  };
  const performDelete = async () => {
    await contentItem.delete();
    setConfirmDelete(false);
  };
  const handleFlashcardModalOnClose = () => {
    setIsEditing(false);
  };

  return (
    <>
      <Flashcard
        id={`flashcard-${contentItem.id}`}
        deleteOnClick={deleteOnClick}
        editOnClick={editOnClick}
        flashcard={contentItem}
      />

      {isEditing ? (
        <FlashcardModal
          flashcard={contentItem}
          onClose={handleFlashcardModalOnClose}
          onCloseAll={handleFlashcardModalOnClose}
          onSave={async (properties) =>
            await contentItem.change(properties).save()
          }
        ></FlashcardModal>
      ) : null}

      {confirmDelete ? (
        <FlashcardDeleteDialog
          isOpen={confirmDelete}
          cancelOnClick={() => {
            setConfirmDelete(false);
          }}
          deleteOnClick={() => {
            performDelete();
          }}
        />
      ) : null}
    </>
  );
}, arePropsEqual);

FlashcardListCard.propTypes = {
  contentItem: PropTypes.object.isRequired,
};

export default FlashcardListCard;
